<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Confirmação de Dados Pessoais</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in dataEmancipated.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0" v-html="dataEmancipated.introduction"></p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <fieldset class="fieldErrors" v-if="errors.count() > 0">
            <legend>Atenção aos erros do formulário:</legend>
            <ul>
              <li
                v-for="(error, index) in errors.all()"
                :key="index"
                class="alert"
              >
                {{ error }}
              </li>
            </ul>
          </fieldset>
          <p v-html="item.message"></p>
          <p style="margin-top: 7.5px" v-if="item.field == 'doc-eman'">
            <label>Documento</label>
            <input
              style="
                width: 100%;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 5px;
                padding: 8.5px;
              "
              ref="certificado"
              type="file"
              accept="image/*,.pdf"
              @change="onFileUploadCertificate"
            />
          </p>
          <div>
            <vs-row>
              <vs-divider />
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="arrow_back"
                  style="width: 100%"
                  @click="back(item, index)"
                  v-if="item.field !== 'doc-eman'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%"
                  color="#139B0E"
                  :disabled="!visibleButtonCertificate"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence />
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel />
        </vs-card>
      </section>
    </div>
  </div>
</template>
<script>
import AuditModel from "../model/Audit.js";
import AuditService from "../services/audits.js";
import MailingService from "../services/mailing.js";
import PersonService from "../services/person";
import { getStepsInformation, notifyError } from "../helpers/index.js";
import Divergence from "../components/Divergence.vue";
import ReasonsCancel from "../components/ReasonsCancel.vue";

export default {
  name: "AuditStep1B",
  components: {
    Divergence,
    ReasonsCancel,
  },
  data: () => ({
    dataEmancipated: null,
    coligateId: null,
    preRegistrationId: null,
    filesCertificate: null,
    base64Certificate: null,
    visibleButtonCertificate: false,
    cities: [],
    states: [],
    personalData: [],
    succesUpdateClient: false,
    error: null,
  }),
  created() {
    this.dataEmancipated = new AuditModel().getItem("emancipated");
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;

    this.$vs.loading();
    new AuditService()
      .getPersonalData(preRegistrationId)
      .then((res) => {
        Object.assign(this.personalData, res.data);
        this.$vs.loading.close();
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    async onFileUploadCertificate(event) {
      this.filesCertificate = event.target.files[0];
      this.createCertificate(this.filesCertificate);
      this.visibleButtonCertificate = true;
    },

    createCertificate(file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        var bynaryData = event.target.result;
        this.base64Certificate = window.btoa(bynaryData);
      };
      reader.readAsBinaryString(file);
    },

    async confirmAdvance(item, index) {
      item.visible = false;
      item.valid = true;
      if (index == this.dataEmancipated.itens.length - 1) {
        this.$validator.validate().then(async (valid) => {
          if (!valid) {
            notifyError(this, "Corrigir os erros apresentados.");
            item.visible = true;
            return;
          } else {
            const payloadAttachment = {
              CODCOLIGADA: this.personalData.CODCOLIGADA,
              CODLOCAL: this.personalData.CODLOCAL,
              CODATENDIMENTO: this.personalData.CODATENDIMENTO,
              FILENAME: this.filesCertificate.name,
              ATTACHMENT: this.base64Certificate
            };

            this.$vs.loading();
            new MailingService()
              .updateAttachmentAttendance(payloadAttachment)
              .then(() => {
                this.saveClientData();
                this.$router.push("/audits/2");
              })
              .catch((error) => {
                notifyError(
                  this,
                  "Erro ao tentar anexar o documento: " + error
                );
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          }
        });
      } else {
        this.dataEmancipated.itens[index + 1].visible = true;
      }
    },

    async saveClientData() {
      this.succesUpdateClient = false;
      const clientData = {
        NOMEFANTASIA: this.personalData.FANTASIA_CLIENTE,
        NOME: this.personalData.NOME_CLIENTE,
        CGCCFO: this.personalData.CPF_CLIENTE,
        TELEFONE: this.personalData.TELEFONE1_CLIENTE.replace(/\D/g, ""),
        TELEX: this.personalData.TELEFONE2_CLIENTE.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_CLIENTE,
        PESSOAFISOUJUR: this.personalData.TIPOPESSOA_CLIENTE,
        DTNASCIMENTO: this.personalData.NASCIMENTO_CLIENTE,
        CODMUNICIPIO: this.personalData.CODMUNICIPIO_CLIENTE,
        CODCOLCFO: this.personalData.COLIGADA_CLIENTE,
        CODCFO: this.personalData.CODIGO_CLIENTE,
        BAIRRO: this.personalData.BAIRRO_CLIENTE,
        CEP: this.personalData.CEP_CLIENTE,
        NUMERO: this.personalData.NUMERO_CLIENTE,
        COMPLEMENTO: this.personalData.COMPLEMENTO_CLIENTE,
        CODETD: this.personalData.ESTADO_CLIENTE,
        TIPORUA: this.personalData.TIPORUA_CLIENTE,
        RUA: this.personalData.NOMERUA_CLIENTE,
        CIDENTIDADE: this.personalData.RG_CLIENTE,
        EMANCIPADO: this.personalData.EMANCIPADO == "S" ? "S" : "",
        isNew: false,
      };
      this.$vs.loading();
      await new PersonService()
        .newClientPerson(clientData)
        .then(() => {
          this.succesUpdateClient = true;
        })
        .catch(( error ) => {
          notifyError(
            this,
            "Erro ao tentar atualizar os dados do responsável: " + error.response.data.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>
<style scoped>
p {
  margin-top: 1em;
}
</style>
